
import { Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import * as Enum from '@/enum';
import store from '@/store';
import { DashboardClient, ShopCategoryClient, ShopOfferClient } from '@/services/Services';
import { LoginServices } from '@/services/LoginServices';
import { Watch, Prop } from 'vue-property-decorator';
import { UploadServices } from '@/services/UploadServices';
import { ModalServices } from '@/services/ModalServices';
import { LocalizationServices } from '@/services/LocalizationServices';

@Options({})
export default class shopPage extends Vue {

    @Prop() readonly: boolean;

    searchText: string = "";
    categories: OM.ShopCategory[] = [];
    // offerteSociCategory: OM.ShopCategory = null;
    popularOffers: OM.ShopOffer[] = [];
    fullTextResponse: OM.ShopFullTextSearchResultVm = null;

    saldo: number = 0;

    created(){
        // ShopCategoryClient.getOfferteRiservateSociCategory()
        // .then(x => {
        //     this.offerteSociCategory = x;
        // })
        ShopCategoryClient.getCategoriesForCliente(store.state.loginData.userIdentifier)
        .then(x => {
            this.categories = x;
        })
        ShopOfferClient.getPopularOffers()
        .then(x => {
            this.popularOffers = x;
        })
        DashboardClient.getSaldo(store.state.user.identifier)
        .then(x => {
            this.saldo = x;
        })
    }

    debouncer = null;
    @Watch('searchText')
    onsearchText(next, prev){
        clearTimeout(this.debouncer);
        if(this.searchText){
            this.debouncer = setTimeout(() => {
                ShopOfferClient.fullTextSearch(this.searchText, store.state.selectedLanguage)
                .then(x => {
                    this.fullTextResponse = x;
                })
            }, 600);
        }
    }

    navTo(where){
        if(this.readonly){
            ModalServices.alertModal(
                LocalizationServices.GetLocalizedValue("Area riservata", "Area riservata"),
                LocalizationServices.GetLocalizedValue("Le offerte sono riservate ai soci AuraClub", "Le offerte sono riservate ai soci AuraClub"),
            )

            return;
        } else {
            this.$router.push(where);
        }
    }

}
